import type { Currency } from '@ps/web-core-enums';
import type { BetDefinition, BettableOpportunities, PlaceBetResult } from '@ps/web-sports-types';

import { type SportsBet, sportsBet } from '../entities';

export const createSportsBetEntity = (
  result: PlaceBetResult,
  betDefinitions: BetDefinition[],
  currency: Currency,
  bettableOpportunities: BettableOpportunities
) => {
  const { betId, betNo, totalStake, totalPotentialWin, betPlacedTime, runners } = result;

  if (!betId || !totalStake || !betPlacedTime || !runners) {
    return null;
  }

  const betType =
    betDefinitions.find((betDefinition) => betDefinition.betNo === betNo)?.betType || 'UNKNOWN';

  const matchingOpportunityId =
    betDefinitions.find((betDefinition) => betDefinition.betNo === betNo)?.id || 'UNKNOWN';

  const placedBetOpportunity = bettableOpportunities.MULTIPLE.find(
    (bettableOpportunity) => bettableOpportunity.id === matchingOpportunityId
  );

  let betCategory: SportsBet['betCategory'] = 'STANDARD';

  const features: string[] = placedBetOpportunity?.features ?? [];

  if (features.includes('SGM_MULTIPLES')) {
    betCategory = 'BET_BUILDER_PLUS';
  } else if (features.includes('SGM')) {
    betCategory = 'BET_BUILDER';
  }

  return sportsBet({
    betCurrency: currency as SportsBet['betCurrency'],
    betType: betType as SportsBet['betType'],
    betId,
    betStake: totalStake,
    betPotentialReturn: totalPotentialWin,
    betPlacedTime: new Date(betPlacedTime).getTime(),
    betCashoutAvailable: false,
    betCashedOut: false,
    isStartingPrice: !totalPotentialWin,
    betCategory
  });
};
